// extracted by mini-css-extract-plugin
export var readonly = "_du-1";
export var star = "_du-0";